import React from "react";
import { useNavigate } from "react-router-dom";
import { objToFormData } from "../../../helpers/FormHelper";
import { createStickerPack } from "../../../actions/sticker_maker/stickerPacksActions";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setNewError, setNewParams, StickerPackInterface } from "../../../store/sticker_maker/stickerPacksSlice";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const New = () => {
  const navigate    = useNavigate();
  const dispatch    = useAppDispatch();
  const newParams   = useAppSelector(state => state.stickerMaker.stickerPacks.newParams);
  const error       = useAppSelector(state => state.stickerMaker.stickerPacks.newError);

  let params = newParams;

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(data: StickerPackInterface) {
    const formData = objToFormData(data);
    handleSave(formData).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createStickerPack(data));

    if (createStickerPack.fulfilled.match(resultAction)) {
      onClose();
      navigate(0);
    }
  }

  return (
    <DrawerRight
      open={!!params}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-stickerPack'>
        <h6 className="v-content-label">Create StickerPack</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={params} />
      </div>
    </DrawerRight>
  )
}

export default New;
